module.exports = __webpack_public_path__ + "img/kzzx.d2f23b2c.jpg";